import React from "react";

export function scheduleSubmittedReset(
  submittedResetRef: React.MutableRefObject<number | null>,
  setSubmitted: (value: boolean) => void,
  delayMs: number = 100
): void {
  if (submittedResetRef.current !== null) {
    cancelAnimationFrame(submittedResetRef.current);
  }
  const startTime = performance.now();
  const check = () => {
    if (performance.now() - startTime >= delayMs) {
      setSubmitted(false);
      submittedResetRef.current = null;
    } else {
      submittedResetRef.current = requestAnimationFrame(check);
    }
  };
  submittedResetRef.current = requestAnimationFrame(check);
}
